import { Component, inject, effect, signal } from '@angular/core';
import { provideI18nScope } from '../../shared/i18n/i18n-scope.provider';
import { I18nScopedService } from '../../shared/i18n/i18n-scoped.service';
import { I18nPipe } from '../../shared/i18n/i18n-pipe';
import { I18nScopeReadyDirective } from '../../shared/i18n/i18n-scope-ready.directive';
import { DashboardService } from '../dashboard/services/dashboard/dashboard.service';
import { Router } from '@angular/router';
import { DashboardListItem } from '../dashboard/models/dashboard-list-item/dashboard-list-item.model';

@Component({
  selector: 'app-dashboards-landing',
  imports: [I18nPipe, I18nScopeReadyDirective],
  templateUrl: './dashboards-landing.html',
  styleUrl: './dashboards-landing.scss',
  providers: [
    provideI18nScope('features/dashboards-landing'),
    I18nScopedService,
  ],
})
export class DashboardsLanding {
  private readonly dashboardService = inject(DashboardService);
  private readonly router = inject(Router);
  dashboards: DashboardListItem[] = [];
  loading = signal<boolean>(true);

  constructor() {
    effect(() => {
      const loaded = this.dashboardService.dashboardListLoaded();
      const allDashboards = this.dashboardService.dashboardList();

      if (!loaded) return;

      this.dashboards = allDashboards.filter(
        (dashboard) => dashboard.isOverview === false,
      );
      this.loading.set(false);

      if (this.dashboards.length > 0) {
        this.router.navigateByUrl('/dashboard/' + this.dashboards[0].name);
      }
    });
  }
}
